import React from "react";
import "../../App.scss"
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import {  Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from "react-i18next";



export default function GraphComp({ doubleGraph, graphData }) {
  const {t} = useTranslation()
  const theme = useTheme()

  return (
    <Stack style={{ background: "#e7ebf4", position: "relative", alignItems: "flex-start", }}>
      {graphData?.length > 0 ? <>
        <Stack direction="row">
          <Stack style={{ height: "300px", width: "20px", alignItems: "center", justifyContent: "center", marginLeft: "20px", marginRight: "-25px" }}>
            <Typography color="#14285A" fontWeight="500" className='rotate-[-90deg] w-[120px] '>
              {t('EU Allowances')}
            </Typography>
          </Stack>
          <Stack className=" !z-[999] ">
            <BarChart
              width={60}
              height={300}
              data={graphData}
              margin={{
                top: 5,
                right: 0,
                left: 0,
                bottom: 30
              }}
            >
              <YAxis stroke="#14285A80" />
              <Bar dataKey="EUA" fill={doubleGraph ? "#FFCC00" : theme.palette.primary.main} barSize={doubleGraph ? 0 : 0} />
              {doubleGraph ? <Bar dataKey="EUACP" fill={theme.palette.primary.main} barSize={0} />
                : null}
            </BarChart>
          </Stack>
          <Stack className="!w-[400px]  overflow-x-auto">
            <BarChart
              width={graphData?.length * 30}
              height={300}
              data={graphData}
              margin={{
                top: 5,
                right: 0,
                left: 0,
                bottom: 0
              }}
            >
              <XAxis dataKey="name" stroke="#000000" tick={{ width: "35px", textAnchor: 'middle', fontSize:'12px'}} />
              <Tooltip content={"Day"} />
              <Bar dataKey="EUA" fill={doubleGraph ? "#FFCC00" : theme.palette.primary.main} barSize={doubleGraph ? 6 : 10} />
              {doubleGraph ? <Bar dataKey="EUACP" fill={theme.palette.primary.main} barSize={6} />
                : null}
            </BarChart>
          </Stack>
        </Stack>
        <Stack style={{ width: "100%", justifyContent: "start", paddingBottom: "20px", alignItems: "center" }}>
          <Typography style={{ color: "#14285A", fontWeight: "500" }}>
          {t('Days')}
          </Typography>
        </Stack>
      </> :
        <Stack style={{ height: "300px", width: "100%", alignItems: "center", justifyContent: "center", }}>
          <Typography>
            {t('No Data Found')}
          </Typography>
        </Stack>
      }
    </Stack>
  );
}